import { AuthProvider, useAuth } from './hooks/useAuth';
import { isSupabaseConfigured } from './lib/supabase';
import AuthScreen from './components/AuthScreen';
import AppLayout from './components/AppLayout';

function AppContent() {
  const { user, profile, loading } = useAuth();

  if (!isSupabaseConfigured) {
    return <AuthScreen mode="missing-config" />;
  }

  if (loading) {
    return (
      <div className="flex min-h-screen items-center justify-center bg-ink-950 text-slate-200">
        <div className="rounded-lg border border-white/10 bg-white/[0.04] px-6 py-5 shadow-panel">
          <div className="mb-3 h-2 w-48 overflow-hidden rounded-full bg-white/10">
            <div className="h-full w-1/2 animate-pulse rounded-full bg-relay-cyan" />
          </div>
          Loading Relay...
        </div>
      </div>
    );
  }

  if (!user || !profile) {
    return <AuthScreen mode="auth" />;
  }

  return <AppLayout />;
}

export default function App() {
  return (
    <AuthProvider>
      <AppContent />
    </AuthProvider>
  );
}

